module.exports = __webpack_public_path__ + "img/hdnj-pic2.84ad1436.png";